import React, { useEffect, useState } from 'react';
import { Alert, Card, Button, Table, Form, Row, Col } from 'react-bootstrap';
import PageHeader from '../../layouts/layoutcomponents/PageHeader';
import { Fragment } from 'react';

import { API_OPERATIONS } from '../../shared/consts/api'
import { useFetch, useTranslation } from '@np/np_webcomponentlib';
import dateFormat from 'dateformat';
import TypeOperationCheckboxList from '../../shared/MasterData/TypeOperationCheckboxList';
import { TypeOperationEnum, TypeStatusOperationEnum } from '../../shared/MasterData/MasterDataTypes';
import StatusCheckboxList from '../../shared/MasterData/StatusCheckboxList';

import CurrencyInput from 'react-currency-input-field';
import { DataForCheckDiffExchangeRate } from './OperationProviderSettleTypes';




import { DateTime } from "luxon";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { formatAmount4 } from '../../shared/utils/formatAmount4';


interface DateTimeInputProps {
  valueUtc?: string; // Дата в UTC (ISO)
  onChange: (utcString: string) => void;
}

const DateTimeInput: React.FC<DateTimeInputProps> = ({ valueUtc, onChange }) => {
  const [localDate, setLocalDate] = useState<Date | null>(null);

  // Устанавливаем локальное значение на основе valueUtc или текущего времени в МСК
  useEffect(() => {
    if (valueUtc) {
      const moscowDate = DateTime.fromISO(valueUtc, { zone: "utc" }).setZone("Europe/Moscow");
      setLocalDate(moscowDate.toJSDate());
    } else {
      const nowMoscow = DateTime.now().setZone("Europe/Moscow");
      setLocalDate(nowMoscow.toJSDate());
      const utcString = nowMoscow.toUTC().toISO({ suppressMilliseconds: true });
      onChange(utcString);
    }
  }, [valueUtc, onChange]);

  const handleChange = (date: Date | null) => {
    setLocalDate(date);

    if (date) {
      const dt = DateTime.fromJSDate(date, { zone: "Europe/Moscow" });
      const utcString = dt.toUTC().toISO({ suppressMilliseconds: true });
      onChange(utcString);
    }
  };

  const formatDisplay = (date: Date | null) => {
    if (!date) return "";
    return DateTime.fromJSDate(date, { zone: "Europe/Moscow" }).toFormat("dd.MM.yyyy HH:mm:ss");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      <DatePicker
        selected={localDate}
        onChange={handleChange}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={1}
        dateFormat="dd.MM.yyyy HH:mm:ss"
        placeholderText="дд.мм.гггг чч:мм:сс"
        customInput={
          <input
            style={{
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          />
        }
      />
      {localDate && (
        <span style={{ fontSize: "12px", color: "var(--trt-text-muted)" }}>
          МСК: {formatDisplay(localDate)}
        </span>
      )}
    </div>
  );
};



//import { toast, Toaster } from 'react-hot-toast';
const SettleFiatMerchant = ({idMerchant}) => {



    const [showWarning, setShowWarning] = useState(false);

    const [showWarningPrepare, setShowWarningPrepare] = useState(false);

   const [showWarningVirtual, setShowWarningVirtual] = useState(false); 

   const [showWarningNotFoundDataForSettle, setShowWarningNotFoundDataForSettle] = useState(false); 


    const [toDate, setToDate] = useState<string | undefined>(undefined);



    const handleDateChange = (utcDate: string) => {
        console.log("Дата в UTC:", utcDate);
        setToDate(utcDate);
        // здесь можно отправлять на сервер или сохранять в форму
    };



    const [forExchangeRate, setForExchangeRate] = useState<number>()

    const [payOutExchangeRate, setPayOutExchangeRate] = useState<number>()
    
    

    const [valueER, setValueER] = useState<string | number>('');

    const validateValueER =  (_value, name, _values): void => {

        setValueER(_value);

        setForExchangeRate(isNaN(_values.float) ? 0 : _values.float);
    };


    const [valuePO, setValuePO] = useState<string | number>('');

    const validateValuePO =  (_value, name, _values): void => {

        setValuePO(_value);

        setPayOutExchangeRate(isNaN(_values.float) ? 0 : _values.float);
    };





    const [resultCalculate, setResultCalculate] = useState<DataForCheckDiffExchangeRate>();

    const [, doCalculateDiffExchangeRate] = useFetch(
        `${API_OPERATIONS}balance/calculatemerchantsettle`)//{ error: errCU, isLoading: isLoadCU, response: respCU }


    const [, doProvidersettle] = useFetch(
        `${API_OPERATIONS}balance/merchantsettle`)//{ error: errCU, isLoading: isLoadCU, response: respCU }

    const [, doProvidervirtualsettle] = useFetch(
        `${API_OPERATIONS}balance/providervirtualsettle`)//{ error: errCU, isLoading: isLoadCU, response: respCU }


    const getData = () => {



   setShowWarning(false);
    setShowWarningPrepare(false);
    setShowWarningVirtual(false);
    setShowWarningNotFoundDataForSettle(false);

    
        if (!toDate || !forExchangeRate || !idMerchant) {
            setShowWarningPrepare(true);
            return;
        }


        doCalculateDiffExchangeRate({
            method: 'POST',
            "Content-Type": "application/json",
            data: {
            toDate: toDate,
            forExchangeRate: forExchangeRate,
            idMerchant: idMerchant,
            basis: "calc"
            }
            }).then(responce => {
                console.log(responce)
                console.log("responce.result.status", responce.result.status)
                if (responce.result.status === "success") {
                    setResultCalculate(responce.data)
                }
                console.log(responce.data)
        })
    }



    const createSettle = () => {
        if (!toDate || !forExchangeRate || !idMerchant) {
            setShowWarningPrepare(true);
            return;
        }
        if (!resultCalculate)
        {
            setShowWarning(true);
        }

        if (resultCalculate?.totalAmountFiat === 0) {
            setShowWarningNotFoundDataForSettle(true);
            return;
        }
        doProvidersettle({
            method: 'POST',
            "Content-Type": "application/json",
            data: {
            toDate: toDate,
            forExchangeRate: forExchangeRate,
            idMerchant: idMerchant,
            basis: "settle"
            }
            }).then(responce => {
                console.log(responce)
                console.log("responce.result.status", responce.result.status)
                if (responce.result.status === "success") {
                    
                }
                console.log(responce.data)
        })
    }

    const createVirtualSettle = () => {
        if (!toDate || !forExchangeRate || !idMerchant) {
            setShowWarningPrepare(true);
            return;
        }

        if (!payOutExchangeRate) {
            setShowWarningVirtual(true);
            return;
        }

        if (!resultCalculate)
        {
            setShowWarning(true);
            return;
        }

        if (resultCalculate?.totalAmountFiat === 0) {
            setShowWarningNotFoundDataForSettle(true);
            return;
        }


        doProvidervirtualsettle({
            method: 'POST',
            "Content-Type": "application/json",
            data: {
            toDate: toDate,
            forExchangeRate: forExchangeRate,
            idMerchant: idMerchant,
            payOutExchangeRate: payOutExchangeRate

            }
            }).then(responce => {
                console.log(responce)
                console.log("responce.result.status", responce.result.status)
                if (responce.result.status === "success") {
                    
                }
                console.log(responce.data)
        })
    }

    


  

  return (<Card>
    <Card.Header>
        <Card.Title as='h4'>{useTranslation('calculateDiffExchangeRate')}</Card.Title>
    </Card.Header>
    <Card.Body className="">
        
        {showWarning && (
            <Alert variant="warning" onClose={() => setShowWarning(false)} dismissible>
                {'Сначала выполните расчет!'}
            </Alert>
        )}

        {showWarningPrepare && (
            <Alert variant="warning" onClose={() => setShowWarningPrepare(false)} dismissible>
                {'Введите дату и курс для расчета!'}
            </Alert>
        )}

        {showWarningVirtual && (
            <Alert variant="warning" onClose={() => setShowWarningVirtual(false)} dismissible>
                {'Введите курс для PayOut!'}
            </Alert>
        )}

        {showWarningNotFoundDataForSettle && (
            <Alert variant="warning" onClose={() => setShowWarningNotFoundDataForSettle(false)} dismissible>
                {'Нет данных для расчета сеттла!'}
            </Alert>
        )}


        



        <Col md={6}>
                <Form.Label className="col-md-3">{useTranslation('toDate')}</Form.Label>
                <Col md={9}>
                <DateTimeInput valueUtc={toDate} onChange={handleDateChange} />
                </Col>
            </Col>


<Col md={6}>
                 
            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('forExchangeRate')}</Form.Label>
                <Col md={9}>
                <CurrencyInput
                id="validationCustom01"
                name="input-1"
                className={`form-control`}
                value={valueER}
                onValueChange={validateValueER}
                placeholder="Для курса"
                prefix={''}
                decimalScale={2}
                step={1}
                groupSeparator={' '}
              />
                </Col>
            </Row>
                 </Col>


           
            
<Col md={6}>
                <Button onClick={() => { getData() }}> {useTranslation('checkProviderSettle')} </Button>
    </Col>



<Col md={6}>



    <Row className="mb-4">  
        <Form.Label className="col-md-3">{useTranslation('startDate')}</Form.Label>
        <Col md={9}>
        <div>
        {resultCalculate?.startDate
            ? DateTime
                .fromISO(resultCalculate.startDate, { zone: 'utc' })
                .setZone('Europe/Moscow')
                .toFormat('dd.MM.yyyy HH:mm:ss')
            : ''}
        </div>
        
        </Col>
    </Row>

    <Row className="mb-4">  
        <Form.Label className="col-md-3">{useTranslation('totalAmountFiat')}</Form.Label>
        <Col md={9}>
        {resultCalculate?.totalAmountFiat ? formatAmount4(resultCalculate.totalAmountFiat) : '0'}
        </Col>
    </Row>


    <h3>Суммы для мерчанта</h3>
<Row className="mb-4">  
        <Form.Label className="col-md-3">{"Сумма мерчанта в валюте платформы"}</Form.Label>
        <Col md={9}>
        {resultCalculate?.totalAmountInProviderRate ? formatAmount4(resultCalculate.totalAmountInProviderRate) : '0'}
        </Col>
    </Row>

<Row className="mb-4">  
        <Form.Label className="col-md-3">{"Комиссия мерачанта"}</Form.Label>
        <Col md={9}>
        {resultCalculate?.totalProviderComission ? formatAmount4(resultCalculate.totalProviderComission) : '0'}
        </Col>
    </Row>

    <Row className="mb-4">  
        <Form.Label className="col-md-3">{"Комиссия мерчанта в валюте платформы"}</Form.Label>
        <Col md={9}>
        {resultCalculate?.totalProviderComissionInProviderRate ? formatAmount4(resultCalculate.totalProviderComissionInProviderRate) : '0'}
        </Col>
    </Row>

    <Row className="mb-4">  
        <Form.Label className="col-md-3">{"К выводу: "}</Form.Label>
        <Col md={9}>
        {resultCalculate?.totalAmountInProviderRate ? formatAmount4((resultCalculate.totalAmountInProviderRate - resultCalculate.totalProviderComissionInProviderRate)) : '0'}
        </Col>
    </Row>
        
    
<h3>Суммы для провайдеров</h3>
    <Row className="mb-4">  
        <Form.Label className="col-md-3">{"Сумма в валюте платформы"}</Form.Label>
        <Col md={9}>
        {resultCalculate?.totalPlatformAmountMerchant ? formatAmount4(resultCalculate.totalPlatformAmountMerchant) : '0'}
        </Col>
    </Row>
    
    <Row className="mb-4">  
        <Form.Label className="col-md-3">{"Коимссия провайдеров в валюте платформы"}</Form.Label>
        <Col md={9}>
        {resultCalculate?.totalPlatformComissionMerchant ? formatAmount4(resultCalculate.totalPlatformComissionMerchant) : '0'}
        </Col>
    </Row>


    <h3>Осталось в фиате (не рассчитано)</h3>
    <Row className="mb-4">  
        <Form.Label className="col-md-3">{"Сумма в фиате"}</Form.Label>
        <Col md={9}>
        {resultCalculate?.totalAmountInFiat ? formatAmount4(resultCalculate.totalAmountInFiat) : '0'}
        </Col>
    </Row>
    
    <Row className="mb-4">  
        <Form.Label className="col-md-3">{"Коимссия мерчанта в фиате"}</Form.Label>
        <Col md={9}>
        {resultCalculate?.totalAmountComissionInFiat ? formatAmount4(resultCalculate.totalAmountComissionInFiat) : '0'}
        </Col>
    </Row>


<hr></hr>


        <Row className="mb-4">  
        <Form.Label className="col-md-3">{useTranslation('differenceExchangeRate')}</Form.Label>
        <Col md={9}>
        {resultCalculate?.differenceExchangeRate ? formatAmount4(resultCalculate.differenceExchangeRate) : '0'}
        </Col>
    </Row>

    




    
</Col>

<Col md={6}>
                <Button onClick={() => { createSettle() }}> {useTranslation('createSettle')} </Button>
    </Col>




<h3>Виртуальный сеттл - для выплат</h3>


<Col md={6}>
                 
            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('payOutExchangeRate')}</Form.Label>
                <Col md={9}>
                <CurrencyInput
                id="validationCustom02"
                name="input-2"
                className={`form-control`}
                value={valuePO}
                onValueChange={validateValuePO}
                placeholder="Курс PayOut"
                prefix={''}
                decimalScale={2}
                step={1}
                groupSeparator={' '}
              />
                </Col>
            </Row>
                 </Col>


<Col md={6}>
                <Button onClick={() => { createVirtualSettle() }}> {useTranslation('createVirtualSettle')} </Button>
    </Col>


            </Card.Body>
            </Card>
            
        )

}

export default SettleFiatMerchant